// extracted by mini-css-extract-plugin
export default {"link":"Signin_link__ZkO5Z"};